import { Link } from '@eventbrite/eds-link';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import {
    NEW_YEARS_EVE_2022_ATL,
    NEW_YEARS_EVE_2022_CHI,
    NEW_YEARS_EVE_2022_DALLAS,
    NEW_YEARS_EVE_2022_DC,
    NEW_YEARS_EVE_2022_HOUSTON,
    NEW_YEARS_EVE_2022_LA,
    NEW_YEARS_EVE_2022_LONDON,
    NEW_YEARS_EVE_2022_MIAMI,
    NEW_YEARS_EVE_2022_NYC,
    NEW_YEARS_EVE_2022_ORLANDO,
    NEW_YEARS_EVE_2022_SF,
} from '../../../../../../../attendee/collection-carousel/src/index';
import './NewYearsContent.scss';

const newYearCollectionMap: newYearCollectionMapProp = {
    '85977539': NEW_YEARS_EVE_2022_NYC,
    '101750367': NEW_YEARS_EVE_2022_LONDON,
    '85933669': NEW_YEARS_EVE_2022_MIAMI,
    '85940195': NEW_YEARS_EVE_2022_CHI,
    '85923517': NEW_YEARS_EVE_2022_LA,
    '85936429': NEW_YEARS_EVE_2022_ATL,
    '85931779': NEW_YEARS_EVE_2022_DC,
    '85922583': NEW_YEARS_EVE_2022_SF,
    '101725629': NEW_YEARS_EVE_2022_HOUSTON,
    '101724385': NEW_YEARS_EVE_2022_DALLAS,
    '85933091': NEW_YEARS_EVE_2022_ORLANDO,
};

interface Props {
    onClickCTA: (e: Event) => void;
    location?: any;
}

type newYearCollectionMapProp = {
    [key: string]: string;
};

export const NewYearsContent = ({ onClickCTA, location }: Props) => {
    const cityBrowseLink = location.isOnline ? '/d/online/events' : '/d/local';
    const linkLabel = location.isOnline
        ? gettext('View Online events')
        : gettext('View %(location)s events', {
              location: location?.currentPlace,
          });

    const locationHasCollection = Boolean(
        newYearCollectionMap[location?.placeId],
    );

    const ctaLink = locationHasCollection
        ? `/c/${newYearCollectionMap[location?.placeId]}`
        : cityBrowseLink;

    return (
        <div className="feed-fullbleed-header__headline">
            <div id="feed-fullbleed-header__header" data-spec="hero-image-text">
                {gettext('Do The New Year Right')}
            </div>
            <div
                className="eds-text-color--white eds-l-mar-right-6"
                id="feed-fullbleed-header__subtitle"
                data-spec="hero-image-text"
            >
                {gettext(
                    "We've curated the best events near you to get your 2023 started.",
                )}
            </div>
            <div className="feed-fullbleed-header__cta-container">
                <Link
                    aria-label={linkLabel}
                    onClick={onClickCTA}
                    to={ctaLink}
                    data-spec="seasonal-cta"
                >
                    <div className="feed-fullbleed-header__button eds-text-weight--heavy ">
                        {linkLabel}
                    </div>
                </Link>
            </div>
        </div>
    );
};
